"use client";

import { useMemo } from "react";

type Props = {
  progressValue: number;
  cardPositions: { x: number; y: number }[];
  gridSize: { w: number; h: number };
};

export default function ConnectionLines({ progressValue, cardPositions, gridSize }: Props) {
  const draw = Math.max(0, Math.min(1, progressValue));

  const { paths, viewBox } = useMemo(() => {
    if (cardPositions.length < 6 || gridSize.w === 0)
      return { paths: { left: [] as string[], right: [] as string[] }, viewBox: "0 0 1 1" };

    const centerX = gridSize.w / 2;
    const hubY = cardPositions.reduce((s, p) => s + p.y, 0) / cardPositions.length;

    const toPath = (cx: number, cy: number) =>
      `M ${centerX} ${hubY} C ${(centerX + cx) / 2} ${hubY}, ${(centerX + cx) / 2} ${cy}, ${cx} ${cy}`;

    return {
      paths: {
        left: cardPositions.slice(0, 3).map((p) => toPath(p.x, p.y)),
        right: cardPositions.slice(3, 6).map((p) => toPath(p.x, p.y)),
      },
      viewBox: `0 0 ${gridSize.w} ${gridSize.h}`,
    };
  }, [cardPositions, gridSize]);

  if (paths.left.length === 0) return null;

  return (
    <svg
      className="absolute inset-0 hidden lg:block pointer-events-none"
      viewBox={viewBox}
      fill="none"
    >
      {paths.left.map((path, i) => (
        <path
          key={`left-${i}`}
          d={path}
          stroke="rgba(56,189,248,.4)"
          strokeWidth="1.5"
          strokeLinecap="round"
          pathLength={1}
          strokeDasharray={`${draw} 1`}
        />
      ))}
      {paths.right.map((path, i) => (
        <path
          key={`right-${i}`}
          d={path}
          stroke="rgba(56,189,248,.4)"
          strokeWidth="1.5"
          strokeLinecap="round"
          pathLength={1}
          strokeDasharray={`${draw} 1`}
        />
      ))}
    </svg>
  );
}
